import type { DashboardConfig, PageDataSettings } from '../types/dashboard-config.js';

/**
 * The config with `settings` applied to its page data settings. A key set to undefined is cleared, and
 * `dataSettings` is dropped once nothing is left in it, so a page that never uses the feature (or has cleared
 * it) saves no `dataSettings` at all. The rest of the config is untouched.
 */
export function withPageDataSettings(config: DashboardConfig, settings: PageDataSettings): DashboardConfig {
  const merged: PageDataSettings = { ...config.dataSettings, ...settings };
  const kept: PageDataSettings = {};
  if (merged.defaultConnectionIdentifier !== undefined) {
    kept.defaultConnectionIdentifier = merged.defaultConnectionIdentifier;
  }
  if (merged.previewScope !== undefined) kept.previewScope = merged.previewScope;

  const { dataSettings: _previous, ...rest } = config;
  return Object.keys(kept).length === 0 ? rest : { ...rest, dataSettings: kept };
}
